// Geo-hjelparar: Kartverket-adresser, Brønnøysund, kartdata og turplanlegging (alt via backend /api/geo).
import api from "@/lib/api";

export const NORWAY_CENTER = [60.39, 5.33]; // Bergen-området (VMS sitt marknadsområde)
export const DEFAULT_ZOOM = 8;

export const DAY_WINDOWS = [
  { value: 30, label: "30 dagar", short: "30 d" },
  { value: 60, label: "60 dagar", short: "60 d" },
  { value: 90, label: "90 dagar", short: "90 d" },
  { value: 180, label: "6 mnd", short: "6 mnd" },
  { value: 0, label: "Alle", short: "Alle" },
];

export const searchAddresses = async (q, limit = 8) => {
  if (!q || q.trim().length < 2) return [];
  const r = await api.get("/geo/addresses", { params: { q, limit } });
  return r.data?.results || [];
};

export const geocodeAddress = async (address) => {
  try {
    const r = await api.post("/geo/geocode", { address });
    return r.data;
  } catch {
    return null;
  }
};

export const reverseGeocode = async (lat, lng) => {
  try {
    const r = await api.get("/geo/reverse", { params: { lat, lng } });
    return r.data;
  } catch {
    return null;
  }
};

export const searchBrreg = async (q, limit = 8) => {
  if (!q || q.trim().length < 2) return [];
  const r = await api.get("/geo/brreg", { params: { q, limit } });
  return r.data?.results || [];
};

export const fetchMapData = async (params) => (await api.get("/geo/map", { params })).data;

export const routePlan = async (machineIds, start) =>
  (await api.post("/geo/route-plan", { machine_ids: machineIds, start: start || null })).data;

export const planTrip = async (stops, date, note) =>
  (await api.post("/geo/plan-trip", { stops, date, note: note || null })).data;

/** Djuplenker til navigasjon for eitt punkt. */
export const navLinks = ({ lat, lng }, label) => {
  const dest = `${Number(lat).toFixed(6)},${Number(lng).toFixed(6)}`;
  return {
    google: `https://www.google.com/maps/dir/?api=1&destination=${dest}&travelmode=driving`,
    apple: `https://maps.apple.com/?daddr=${dest}&dirflg=d${label ? `&q=${encodeURIComponent(label)}` : ""}`,
  };
};

export const isAppleDevice = () =>
  typeof navigator !== "undefined" && /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent || "");

export const haversineKm = (a, b) => {
  if (!a || !b) return null;
  const R = 6371;
  const toRad = (x) => (x * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const p1 = toRad(a.lat);
  const p2 = toRad(b.lat);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(p1) * Math.cos(p2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

export const formatKm = (km) => {
  if (km === null || km === undefined) return "";
  if (km < 1) return `${Math.round(km * 1000)} m`;
  if (km < 10) return `${km.toFixed(1).replace(".", ",")} km`;
  return `${Math.round(km)} km`;
};

/** Telefon-GPS (Promise). Avvist -> null. */
export const getCurrentPosition = (opts = {}) =>
  new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy_m: p.coords.accuracy }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000, ...opts }
    );
  });

export const POSITION_SOURCE_LABEL = {
  customer: "Kundens adresse",
  machine: "Overstyrt plassering",
};
export const LOCATION_SOURCE_LABEL = {
  manual: "Lagt inn manuelt",
  gps: "Frå GPS",
  report: "Sist sett via rapport",
  customer: "Kundens adresse",
  kartverket: "Kartverket",
  brreg: "Brønnøysund",
};

export const STATUS_ORDER = { overdue: 0, upcoming: 1, ok: 2 };
export const worstOf = (list) => {
  let best = null;
  for (const s of list) {
    if (!(s in STATUS_ORDER)) continue;
    if (best === null || STATUS_ORDER[s] < STATUS_ORDER[best]) best = s;
  }
  return best;
};
